import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";
import ColumnsDetail from "../views/ColumnsDetail.vue";
import ColumnsPlay from "../views/ColumnsPlay.vue";
import ColumnsVideoPlay from "../views/ColumnsVideoPlay.vue";
import TopNewsList from "../views/TopNewsList.vue";
import ArticleDetail from "../views/ArticleDetail.vue";
import LivingDetail from "../views/LivingDetail.vue";
import SevenDaysRecord from "../views/SevenDaysRecord.vue";
import RateSpecial from "../views/RateSpecial.vue";
import Anchor from "../views/Anchor.vue";
import Special from "../views/Special.vue";
import VoteActivity from "../views/Activity/VoteActivity.vue";
import VoteActivityItem from "../views/Activity/VoteActivityItem.vue";
// import LivingStreaming from "../views/LivingStreaming.vue";
import LivingStreaming from "@/views/LivingStreaming";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/ColumnsDetail",
    name: "ColumnsDetail",
    component: ColumnsDetail
    // children: [
    //   {
    //     path: "/ColumnsDetail/ColumnsPlay",
    //     name: "ColumnsPlay",
    //     component: ColumnsPlay
    //   },
    //   {
    //     path: "/ColumnsDetail/ColumnsVideoPlay",
    //     name: "ColumnsVideoPlay",
    //     component: ColumnsVideoPlay
    //   }
    // ]
  },
  {
    path: "/ColumnsPlay",
    name: "ColumnsPlay",
    component: ColumnsPlay
  },
  {
    path: "/ColumnsVideoPlay",
    name: "ColumnsVideoPlay",
    component: ColumnsVideoPlay
  },
  {
    path: "/LivingDetail",
    name: "LivingDetail",
    component: LivingDetail
  },
  {
    path: "/SevenDaysRecord",
    name: "SevenDaysRecord",
    component: SevenDaysRecord
  },
  {
    path: "/RateSpecial",
    name: "RateSpecial",
    component: RateSpecial
  },
  {
    path: "/Anchor",
    name: "Anchor",
    component: Anchor
  },
  {
    path: "/TopNewsList",
    name: "TopNewsList",
    component: TopNewsList
  },
  {
    path: "/ArticleDetail",
    name: "ArticleDetail",
    component: ArticleDetail
  },
  {
    path: "/Special",
    name: "Special",
    component: Special
  },
  {
    path: "/VoteActivity",
    name: "VoteActivity",
    component: VoteActivity
  },
  {
    path: "/VoteActivityItem",
    name: "VoteActivityItem",
    component: VoteActivityItem
  },
  {
    path: "/LivingStreaming",
    name: "LivingStreaming",
    component: LivingStreaming
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  // },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export default router;
